import { render, staticRenderFns } from "./CaseRecordLog.vue?vue&type=template&id=75b20fe7&scoped=true"
import script from "./CaseRecordLog.vue?vue&type=script&lang=js"
export * from "./CaseRecordLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b20fe7",
  null
  
)

export default component.exports